module.exports = __webpack_public_path__ + "img/samsung_as17f_purple.e257ec2.jpg";